(function() {
  function showAllSpecifications() {
    $(document).on('click', '.ph-productdetailpage__featurebuttonall', function() {
      $('.ph-productdetailpage__featuretoggle').removeClass('ph-d-none');
      $('.ph-productdetailpage__featurebuttonless').removeClass('ph-d-none');
      $('.ph-productdetailpage__featurebuttonall').addClass('ph-d-none');
    });
    $(document).on('click', '.ph-productdetailpage__featurebuttonless', function() {
      $('.ph-productdetailpage__featuretoggle').addClass('ph-d-none');
      $('.ph-productdetailpage__featurebuttonless').addClass('ph-d-none');
      $('.ph-productdetailpage__featurebuttonall').removeClass('ph-d-none');
      window.scrollTo(0, $('.ph-productdetailpage__featurespecification').offset().top);
    });
  }

  if ($('.page-productDetails').length > 0) {
    showAllSpecifications();
  }

  $(document).find('.ph-printer').on('click', function(u) {
    u.preventDefault();
    window.print();
  });

  function share() {
    var hrefvalue = $(document).find('.ph-share').attr('href');

    var currentpdpurl = window.location.href;
    var res = hrefvalue.replace('pageurl', currentpdpurl);

    $('.ph-share').attr('href', res);
  }

  $(document).ready(function() {
    var pdpshare = document.getElementsByClassName('ph-share');

    if (pdpshare.length > 0) {
      share();
    }

    $('.ph-productdetailpage__resourcesbox').each(function() {
      var manualName = '',
          description = '',
          url = '';

      manualName = $(this).find('.ph-pdp__manualName').html();
      description = $(this).find('.ph-pdp__manualName').attr('data-description');
      url = $(this).find('.ph-pdp__manualName').attr('data-url');

      if (manualName && description && manualName.length === 0) {
        $(this).find('.ph-pdp__manualName').html(description).attr('title', description);
      }

      if (manualName && description && url && manualName.length === 0 && description.length === 0) {
        $(this).find('.ph-pdp__manualName').attr('title', url);
        $(this).find('.ph-pdp__manualName').html(url);
      }
    });

    $('.ph-productdetail__casestudy').each(function() {
      var casestudy = '',
          casestudydescription = '',
          casestudyurl = '';


      casestudy = $(this).find('.ph-pdp__casestudy').html();
      casestudydescription = $(this).find('.ph-pdp__casestudy').attr('data-descriptioncasestudy');
      casestudyurl = $(this).find('.ph-pdp__casestudy').attr('data-urlcasestudy');


      if (casestudy && casestudy.length === 0) {
        $(this).find('.ph-pdp__casestudy').html(casestudydescription);
      }

      if (casestudy && casestudy.length === 0 && casestudydescription && casestudydescription.length === 0) {
        $(this).find('.ph-pdp__casestudy').html(casestudyurl);
      }
    });
  });
})();
